/*用户管理接口*/
import axios from "../index";
import api from "./AccountSetting.api";

export default {
  /**
   * 查看用户详情  @data
   */
  getUserInfo(data = {}) {
    return axios.post(api.getUserInfo, data);
  },
  /**
   * 修改用户详情  @data "major": "所在专业", "nickName": "昵称", "qq": 0, "realName": "真实姓名", "resume": "个性签名", "school": "所在学校","sex": 性别：0男，1女;
   */
  updateUserInfo(data = {}) {
    return axios.post(api.updateUserInfo, data);
  },
  /**
   * 存头像路徑  @data "photoUrl": "string"
   */
  uploadUserPhoto(data = {}) {
    return axios.post(api.uploadUserPhoto, data);
  },
  /**
   * UC平台上传头像  @data
   */
  UploadImage(data) {
    // debugger;
    return axios({
      method: "post",
      url: api.UploadImage,
      data,
      headers: { "Content-Type": "multipart/form-data" }
    });
  },
  /**
   * 修改用户密码  @data
   */
  updatePassword(data = {}) {
    return axios.post(api.updatePassword, data);
  },
  /**
   * 发送验证码  @data
   */
  sendMobileCode(data = {}) {
    return axios.post(api.sendMobileCode, data);
  },
  /**
   * 绑定手机号  @data
   */
  bindMobilePhone(data = {}) {
    return axios.post(api.bindMobilePhone, data);
  },
  /**
   * 绑定邮箱  @data
   */
  bindEmail(data = {}) {
    return axios.post(api.bindEmail, data);
  }
};
